import React from 'react';
import { observer } from 'mobx-react';
import Link from 'next/link';
import { useAction } from 'next-safe-action/hooks';

import { LoadingIcon } from '@rescui/icons';

import IaButton from '@/components/common/webteam/IaButton/IaButton';
import IaMenuItem from '@/components/common/webteam/IaMenuItem/IaMenuItem';
import { logInLogOut } from '@/components/common/webteam/IaSiteHeader/parts/actions';
import { useStores } from '@/hooks';

import styles from './LoginLogoutButton.module.scss';

const LoginLogoutButton: React.FC = () => {
  const { userStore } = useStores();
  const isSignedIn = !!userStore.me;

  const { execute, isExecuting } = useAction(logInLogOut, {
    onSuccess: ({ data }) => {
      if (data?.result) {
        window.location.href = '/';
      }
    },
  });

  const buttonText = isSignedIn ? 'Sign out' : 'Sign in';
  const buttonMode = isSignedIn ? 'outline' : 'rock';

  return (
    <>
      <div className={styles.dropdownMenuItem}>
        {!isSignedIn && (
          <Link href="/register">
            <IaMenuItem>Register</IaMenuItem>
          </Link>
        )}
        <IaMenuItem onClick={() => execute()}>{buttonText}</IaMenuItem>
      </div>

      <div className={styles.buttons}>
        {!isSignedIn && (
          <Link href="/register">
            <IaButton mode="outline" theme="dark">
              Register
            </IaButton>
          </Link>
        )}

        <IaButton
          disabled={isExecuting}
          icon={isExecuting ? <LoadingIcon /> : undefined}
          mode={buttonMode}
          theme="dark"
          type="submit"
          onClick={() => execute()}
        >
          {buttonText}
        </IaButton>
      </div>
    </>
  );
};

export default observer(LoginLogoutButton);
